import { render, staticRenderFns } from "./ReservationBasicData.vue?vue&type=template&id=6b25be6c"
import script from "./ReservationBasicData.vue?vue&type=script&lang=js"
export * from "./ReservationBasicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports